/*
    Custom Meta Function for node web server.
    https://github.com/zocdoc-patient/node-web-server-lib#routeconfiguration

    Injecting Structured Data for SEO
    ex)
    https://search.google.com/structured-data/testing-tool/u/0/#url=https%3A%2F%2Fwww.sharecare.com%2F
*/

import { getThemeParameters } from '../config/theme/selector';
import { getLocation } from '../config/location/selectors';

export default ({ state }) => {
    const url = 'https://www.zocdoc.com/';
    const description = 'Zocdoc is the beginning of a better healthcare experience for millions of patients every month. Find doctors you love, read real reviews, book appointments instantly, and more.';
    const name = 'Zocdoc';
    const foundingDate = '2007';
    const sameAs = [
        'https://www.facebook.com/Zocdoc/',
        'https://twitter.com/zocdoc',
        'https://plus.google.com/+zocdoc',
        'https://www.linkedin.com/company/zocdoc',
        'https://en.wikipedia.org/wiki/Zocdoc',
        'https://play.google.com/store/apps/details?id=com.zocdoc.android&hl=en',
        'https://itunes.apple.com/us/app/zocdoc-find-book-a-doctor/id391062219?mt=8',
    ];

    const organizationMetadata = {
        '@context': 'http://schema.org',
        '@type': 'Organization',
        url,
        description,
        name,
        foundingDate,
        sameAs,
    };

    const theme = getThemeParameters(state);

    const links = [];
    if (theme && theme.languages) {
        const hostUrl = getLocation(state).host;
        // first list all alternative languages to the one being used
        Object.keys(theme.languages).forEach(language => {
            if (theme.languages[language].host !== hostUrl) {
                links.push({
                    rel: 'alternate',
                    hreflang: theme.languages[language].hreflang,
                    href: `https://${theme.languages[language].host}`,
                });
            }
        });
        // then list the current language
        Object.keys(theme.languages).forEach(language => {
            if (theme.languages[language].host === hostUrl) {
                links.push({
                    rel: 'alternate',
                    hreflang: theme.languages[language].hreflang,
                    href: `https://${theme.languages[language].host}`,
                });
            }
        });
        // finally push default alternative link
        links.push({
            rel: 'alternate',
            hreflang: 'x-default',
            href: 'https://www.zocdoc.com',
        });
    }

    return {
        title: 'Zocdoc: Find a Doctor, Reviews, & Book Appointments',
        jsonLd: [
            organizationMetadata,
        ],
        links,
        description,
    };
};
